// src/app/toolbar-action-contributors.ts

import {
    eIdentityComponents,
    IdentityToolbarActionContributors
  } from '@abp/ng.identity';
  import { IdentityUserDto } from '@abp/ng.identity/proxy';
  import { ToolbarAction, ToolbarActionList } from '@abp/ng.components/extensible';
import { CustomIdentityUserService } from '@proxy/identity';
  
const logUserNames = new ToolbarAction<IdentityUserDto[]>({
  text: 'Export',
  action: data => {
    // Replace log with your custom code
    //data.record.forEach(user => console.log(user.userName));
    var userservice = data.getInjected(CustomIdentityUserService)

    userservice.exportUserlist().subscribe(
      response => {
        let url = response.mimeType + ',' + response.content;
        const downloadLink = document.createElement('a');
        //const fileName = 'sample.pdf';

        downloadLink.href = url;
        downloadLink.download = 'UserList.xlsx';
        downloadLink.click();
      },
      error => {}
    );

  },
  // See ToolbarActionOptions in API section for all options
});

export function logUserNamesContributor(actionList: ToolbarActionList<IdentityUserDto[]>) {
  actionList.addHead(logUserNames);
}

export const identityToolbarActionContributors: IdentityToolbarActionContributors = {
  // enum indicates the page to add contributors to
  [eIdentityComponents.Users]: [
    logUserNamesContributor, // Re-enabled for ABP v7
    // You can add more contributors here
  ],
};
  
  